module.exports = __webpack_public_path__ + "img/Weapon_115.d749db6e.png";